import { render, staticRenderFns } from "./tab-panel.vue?vue&type=template&id=59317b20"
import script from "./tab-panel.vue?vue&type=script&lang=js"
export * from "./tab-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports